<template>
    <div>

            <form @submit.prevent="handleSubmit">
                <div class="form-group-list">
                    <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:50%" label="键" type="text" id="name"
                                :modelValue="form.name" required placeholder="请输入键"
                                @update:modelValue="(value) => handleModelValueUpdate('name', value)"
                    />
                    <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:50%" label="值" type="text" id="value"
                                :modelValue="form.value" required placeholder="请输入值"
                                @update:modelValue="(value) => handleModelValueUpdate('value', value)"
                    />
                </div>
                <div class="form-group-list">
                    <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:50%" label="图标" type="text" id="icon"
                                :modelValue="form.icon" required placeholder="请输入图标"
                                @update:modelValue="(value) => handleModelValueUpdate('icon', value)"
                    />
                    <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:50%" label="排序" type="text" id="sort"
                                :modelValue="form.sort" required placeholder="请输入排序"
                                @update:modelValue="(value) => handleModelValueUpdate('sort', value)"
                    />
                </div>
                <div class="form-group-list" style="margin: 0.5rem 0;">
                    <label class="form-label" style="color:#94a3b8;">
                        所属字典
                    </label>
                    <a-cascader placeholder changeOnSelect style="width: 88%"
                        v-decorator="[ 'pid', { rules: [{ required: true, message: '请选择' }] },]"
                                :options="dataDictTree" :fieldNames="{label: 'name',value: 'key',children: 'children',}"/>
                </div>
                <div class="right" style="margin: 1rem 0 0 0;">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" primary @click="handleSubmit"/>
                    </a-space>
                </div>
            </form>
    </div>
</template>

<script>
import { edit, add } from "@/api/setting/data-dict";

import { mapState } from "vuex";
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
export default {
    components: {InputField,ButtonField},
  props: {
    visible: {
      type: Boolean,
    },
    text: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      form: {},
      id: null,
    };
  },

  computed: {
    ...mapState("setting", ["dataDict", "rawDataDict"]),
    dataDictTree() {
      return [
        {
          id: "根字典",
          key: "根字典",
          name: "根字典",
          value: "根字典",
          pid: null,
          children: this.dataDict,
        },
      ];
    },
    title() {
      if (this.text.id) {
        return "编辑字典";
      }
      return "新建字典";
    },
  },

  watch: {
    text(newVal) {
      const list = [newVal.pid];
      this.buildSelectedPid(list, newVal.pid);

      this.id = newVal.id;

      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: newVal.name,
          value: newVal.value,
          icon: newVal.icon,
          sort: newVal.sort,
          pid: list,
        });
      });
    },
  },
  mounted() {
      console.log("this.text",this.$props.text)
      this.form = this.$props.text;
  },
  methods: {
  handleModelValueUpdate(fieldName, value) {
      this.form[fieldName] = value;
  },
    cancel() {
      this.$emit("cancel");
    },

    buildSelectedPid(list, pid) {
      const obj = this.rawDataDict.find((item) => item.id === pid);
      if (obj) {
        if (obj.pid === null) {
          list.unshift("根字典");
        } else {
          list.unshift(obj.pid);
          this.buildSelectedPid(list, obj.pid);
        }
      }
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let pid = values.pid[values.pid.length - 1];

          if (pid === "根字典") {
            pid = undefined;
          }

          if (this.text.id) {
            edit({
              ...values,
              id: this.id,
              pid,
            }).then(() => {
              this.cancel();
            });
          } else {
            add({
              ...values,
              pid,
            }).then(() => {
              this.cancel();
            });
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.form-group-list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 95%;
}
::v-deep .ant-cascader-picker{
    background-color: #0e1932;
    color:#fff;
    padding: 1.4rem 0;
    border-radius: 10px;
    border: 1px solid #0b4846;
}
::v-deep .ant-cascader-picker-arrow{
    color: rgb(255 255 255 / 25%);
}
::v-deep .ant-input{
    display: none;
    height:80px;
}
::v-deep .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled), .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover{
    background-color: rgba(0, 255, 150, 0.1);
}
::v-deep .ant-cascader-menus{
    background: #0a0e27!important;
}

</style>